import React, { useEffect, useState } from "react";
import "./FixedCostScreen.css";
import Button from "../../components/Button/Button";
import Header from "../../components/Header/Header";
import Navbar from "../../components/Navbar/Navbar";

/**Firebase Imports**/
import {
	auth,
	db,
	collection,
	setDoc,
	getDoc,
	doc,
} from "../../firebaseConfig";
import { showError } from "../../helpers/showError";
import DynamicTextInput from "../../components/DynamicTextInput/DynamicTextInput";
import BackDrop from "../../components/BackDrop/BackDrop";
import AddInputForm from "./AddInputForm/AddInputForm";

const FixedCostScreen = () => {
	const costsRef = collection(db, "fixed_costs");

	const [showAddInput, setShowAddInput] = useState(false);
	const [checkErrors, setcheckErrors] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);

	const [annualInputs, setAnnualInputs] = useState([]);
	const [monthlyInputs, setMonthlyInputs] = useState([]);

	const [annualCost, setAnnualCost] = useState(0); //Annual result
	const [monthlyCost, setMonthlyCost] = useState(0); //monthly result

	/**
	 * Main Functions
	 * **/

	const handleUpdate = async () => {
		setIsProcessing(true);
		setcheckErrors(true);
		var annualErrors = annualInputs.find((x) => x.value === "");
		var monthlyErrors = monthlyInputs.find((x) => x.value === "");
		if (annualErrors || monthlyErrors) {
			setIsProcessing(false);
			return;
		}

		await setDoc(doc(costsRef, auth.currentUser.uid), {
			annualInputs: annualInputs,
			monthlyInputs: monthlyInputs,
		})
			.then(() => {
				//costs updated
				alert("Costs updated successfully");
				setIsProcessing(false);
			})
			.catch((error) => {
				showError(error);
				setIsProcessing(false);
			});
	};

	useEffect(() => {
		const getInputs = async () => {
			const docSnap = await getDoc(
				doc(db, "fixed_costs", auth.currentUser.uid)
			);
			if (docSnap.exists()) {
				const annualInputsTemp = docSnap.data().annualInputs;
				const monthlyInputsTemp = docSnap.data().monthlyInputs;
				if (annualInputsTemp !== undefined && monthlyInputsTemp !== undefined) {
					setAnnualInputs(annualInputsTemp);
					setMonthlyInputs(monthlyInputsTemp);
				} else {
					setAnnualInputs([
						{ name: "Annual Insurance", value: "" },
						{ name: "IRS 2290", value: "" },
						{ name: "Registration", value: "" },
					]);
					setMonthlyInputs([
						{
							name: "Monthy Breakdown From AI",
							value: "",
							readonly: true,
						},
						{ name: "Equipment Payment", value: "" },
						{ name: "IFTA", value: "" },
					]);
				}
			} else {
				setAnnualInputs([
					{ name: "Annual Insurance", value: "" },
					{ name: "IRS 2290", value: "" },
					{ name: "Registration", value: "" },
				]);
				setMonthlyInputs([
					{
						name: "Monthy Breakdown From AI",
						value: "",
						readonly: true,
					},
					{ name: "Equipment Payment", value: "" },
					{ name: "IFTA", value: "" },
				]);
			}
		};
		getInputs();
		return () => console.log("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth.currentUser]);

	// update Result
	const updateResult = () => {
		setAnnualCost(annualInputs.reduce((x, a) => x + parseFloat(a.value), 0));
		setMonthlyCost(monthlyInputs.reduce((x, a) => x + parseFloat(a.value), 0));
		console.log("Result Updated");
	};
	useEffect(() => {
		updateResult();
		return () => "";
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [annualInputs, monthlyInputs]);

	/** **/

	return (
		<div className="FixedCostScreen h-full w-full overflow-y-auto m-0 p-3 py-8">
			<div className="h-full w-full m-0 p-0">
				{showAddInput && (
					<>
						<BackDrop onClick={() => setShowAddInput(false)} />
						<AddInputForm
							array={showAddInput}
							annualInputs={annualInputs}
							monthlyInputs={monthlyInputs}
							setAnnualInputs={setAnnualInputs}
							setMonthlyInputs={setMonthlyInputs}
							setShowAddInput={setShowAddInput}
						/>
					</>
				)}

				<Navbar backTarget={"/landing"} />
				<Header className={"mt-8"} size={"medium"}>
					FIXED COST
				</Header>

				<div
					className="annualFixedCosts text-start pr-14 items-center flex flex-col mx-auto"
					style={{ maxWidth: 550 }}
				>
					<Header className={"my-4 mr-auto"} size={"small"}>
						Annual Fixed Cost
					</Header>
					<Button
						mode={"filled"}
						title={"ADD+"}
						size={"sm"}
						className={"my-2 mr-auto"}
						onClick={() => {
							setShowAddInput(1);
						}}
					/>
					<br />
					{
						// dynamic annual inputs
						annualInputs.map(({ name, value }, index) => (
							<DynamicTextInput
								key={index}
								id={index}
								value={value}
								array={annualInputs}
								name={name}
								type={"number"}
								placeholder={name}
								className={"my-2 shadow-none"}
								checkErrors={checkErrors}
								updateResult={updateResult}
							/>
						))
					}
				</div>

				<div
					className="calculations mt-9 mb-6 text-start flex flex-col mx-auto"
					style={{ maxWidth: 550 }}
				>
					<p className="cost my-2">
						Total Annual Fixed Cost:{" "}
						<span className="result">${annualCost}</span>
					</p>
					<p className="cost my-2">
						Monthly Breakdown:{" "}
						<span className="result">${(annualCost / 12).toFixed(2)}</span>
					</p>
				</div>

				<div
					className="monthlyFixedCosts  text-start pr-14 items-center flex flex-col mx-auto"
					style={{ maxWidth: 550 }}
				>
					<Header className={"my-4 mr-auto"} size={"small"}>
						Monthly Fixed Cost
					</Header>
					<Button
						mode={"filled"}
						title={"ADD+"}
						size={"sm"}
						className={"my-2 mr-auto"}
						onClick={() => {
							setShowAddInput(2);
						}}
					/>
					<br />
					{
						// dynamic weekly inputs
						monthlyInputs.map(({ name, value, readonly }, index) => (
							<DynamicTextInput
								readonly={readonly === true ? true : false}
								key={index}
								id={index}
								value={value}
								array={monthlyInputs}
								name={name}
								type={"number"}
								placeholder={name}
								className={"my-2 shadow-none"}
								checkErrors={checkErrors}
								updateResult={updateResult}
								annCost={annualCost}
							/>
						))
					}
				</div>

				<div
					className="calculations mt-9 mb-6 text-start flex flex-col mx-auto"
					style={{ maxWidth: 550 }}
				>
					<p className="cost my-2">
						Total Monthly Fixed Cost:{" "}
						<span className="result">${monthlyCost.toFixed(2)}</span>
					</p>
					<p className="cost my-2">
						Total Weekly Fixed Cost:{" "}
						<span className="result">
							{/* ${(((annualCost / 12 + monthlyCost) * 12) / 52).toFixed(2)} */}
							${((monthlyCost * 12) / 52).toFixed(2)}
						</span>
					</p>
				</div>

				<Button
					mode={"filled"}
					size={"lg"}
					title={isProcessing ? "o o o" : "UPDATE"}
					disabled={isProcessing}
					className={"mb-4"}
					onClick={() => handleUpdate()}
				/>
			</div>
		</div>
	);
};

export default FixedCostScreen;
